import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import Features from './components/Features';
import Funeraria from './components/Funeraria';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Cemiterios from './components/Cemiterios';
import Planos from './components/Planos';
import Cremacao from './components/Cremacao';
import VelorioOnline from './components/VelorioOnline';

// Componente para gerenciar o scroll
const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    // Se tem hash, faz scroll para a seção correspondente
    if (location.hash) {
      const hash = location.hash.substring(1); // Remove o #
      
      // Mapeamento de hashes para IDs das seções
      const hashToIdMap = {
        'sobre': 'about',
        'funeraria': 'funeraria',
        'contact': 'contact',
        'contato': 'contact'
      };
      
      const targetId = hashToIdMap[hash] || hash;
      const element = document.getElementById(targetId);
      
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
      }
    } else {
      // Se não tem hash, faz scroll para o topo
      window.scrollTo(0, 0);
    }
  }, [location.pathname, location.hash]);

  return null;
};

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={
          <>
            <Hero />
            <Services />
            <About />
            <Features />
            <Funeraria />
            {/*<Testimonials />*/}
            <Contact />
          </>
        } />
        <Route path="/cremacao" element={<Cremacao />} />
        <Route path="/cemiterios" element={<Cemiterios />} />
        <Route path="/planos" element={<Planos />} />
        <Route path="/velorio-online" element={<VelorioOnline />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
